[
    {
        "plugin": "Heatmap",
        "plugin_config": {},
        "title": "Heatmap",
        "group_by": ["bucket(\"timestamp\", 'm')"],
        "split_by": ["bucket(\"price\", 0.5)"],
        "columns": ["if(\"side\"=='buy'){-1}else{1}"],
        "filter": [],
        "sort": [],
        "expressions": {
            "bucket(\"timestamp\", 'm')": "bucket(\"timestamp\", 'm')",
            "bucket(\"price\", 0.5)": "bucket(\"price\", 0.5)",
            "if(\"side\"=='buy'){-1}else{1}": "if(\"side\"=='buy'){-1}else{1}"
        },
        "aggregates": {}
    },
    {
        "plugin": "Heatmap",
        "plugin_config": {},
        "title": "Heatmap (Closed)",
        "group_by": ["bucket(\"timestamp\", 'm')"],
        "split_by": ["bucket(\"price\", 0.25)"],
        "columns": ["if(\"side\"=='buy'){-1}else{1}"],
        "filter": [["status", "==", "closed"]],
        "sort": [],
        "expressions": {
            "bucket(\"timestamp\", 'm')": "bucket(\"timestamp\", 'm')",
            "bucket(\"price\", 0.25)": "bucket(\"price\", 0.25)",
            "if(\"side\"=='buy'){-1}else{1}": "if(\"side\"=='buy'){-1}else{1}"
        },
        "aggregates": {}
    },
    {
        "plugin": "Y Scatter",
        "plugin_config": {},
        "title": "Closed Orders ((s) bucket)",
        "group_by": ["bucket(\"timestamp\", 's')"],
        "split_by": ["if(\"status\"!='open'){\"status\"}else{\"side\"}"],
        "columns": ["price"],
        "filter": [],
        "sort": [],
        "expressions": {
            "if(\"status\"=='closed'){1}else if(\"status\"=='expired'){2}else{0}": "if(\"status\"=='closed'){1}else if(\"status\"=='expired'){2}else{0}",
            "if(\"status\"!='open'){\"status\"}else{\"side\"}": "if(\"status\"!='open'){\"status\"}else{\"side\"}",
            "bucket(\"timestamp\", 's')": "bucket(\"timestamp\", 's')"
        },
        "aggregates": { "price": "avg", "timestamp": "dominant" }
    },
    {
        "plugin": "X/Y Scatter",
        "plugin_config": {},
        "title": "Closed Orders",
        "group_by": [],
        "split_by": [],
        "columns": [
            "timestamp",
            "price",
            "if(\"status\"!='open'){\"status\"}else{\"side\"}"
        ],
        "filter": [],
        "sort": [],
        "expressions": {
            "if(\"status\"!='open'){\"status\"}else{\"side\"}": "if(\"status\"!='open'){\"status\"}else{\"side\"}",
            "if(\"status\"=='closed'){1}else if(\"status\"=='expired'){2}else{0}": "if(\"status\"=='closed'){1}else if(\"status\"=='expired'){2}else{0}"
        },
        "aggregates": {}
    },
    {
        "plugin": "Y Line",
        "plugin_config": { "zoom": { "k": 1, "x": 1, "y": -1 } },
        "title": "Mid Timeseries",
        "group_by": ["bucket(\"timestamp\", 's')"],
        "split_by": ["status", "side"],
        "columns": ["price"],
        "filter": [["status", "==", "closed"]],
        "sort": [],
        "expressions": {
            "bucket(\"timestamp\", 's')": "bucket(\"timestamp\", 's')"
        },
        "aggregates": { "price": "avg" }
    },
    {
        "plugin": "Y Bar",
        "plugin_config": {},
        "title": "Depth Timeseries",
        "group_by": ["bucket(\"timestamp\", 'm')"],
        "split_by": ["side", "status"],
        "columns": ["if(\"side\"=='buy'){1}else{-1}"],
        "filter": [],
        "sort": [],
        "expressions": {
            "bucket(\"timestamp\", 'm')": "bucket(\"timestamp\", 'm')",
            "if(\"side\"=='buy'){1}else{-1}": "if(\"side\"=='buy'){1}else{-1}",
            "if(\"side\"=='sell'){-1}else{integer(null)}": "if(\"side\"=='sell'){-1}else{integer(null)}"
        },
        "aggregates": { "bucket(\"timestamp\", 'm')": "dominant" }
    },
    {
        "columns_config": {
            "Diff from market open": {
                "fg_mode": "bar",
                "fg_gradient": 12.9
            },
            "if(\"side\"=='buy'){-1}else{1}": {
                "fg_mode": "bar",
                "fg_gradient": 8,
                "aggregate_depth": 1
            },
            "status": {
                "bg_mode": "series"
            },
            "side": {
                "bg_mode": "series"
            }
        },
        "plugin": "Datagrid",
        "plugin_config": {},
        "settings": true,
        "title": "Blotter",
        "group_by": [],
        "split_by": [],
        "sort": [["timestamp", "desc"]],
        "filter": [],
        "expressions": {
            "bucket(\"price\", 1)": "bucket(\"price\", 1)",
            "bucket(\"timestamp\", 'm')": "bucket(\"timestamp\", 'm')",
            "Diff from market open": "\"price\" - 20"
        },
        "columns": [
            "timestamp",
            "id",
            "Diff from market open",
            "price",
            "status",
            "side"
        ],
        "aggregates": {}
    },
    {
        "columns_config": {
            "if(\"side\"=='buy'){-1}else{1}": {
                "aggregate_depth": 1,
                "fg_mode": "bar",
                "fg_gradient": 8
            }
        },
        "plugin": "Datagrid",
        "plugin_config": {},
        "settings": true,
        "title": "Order Book",
        "group_by": ["bucket(\"price\", 0.5)"],
        "split_by": ["side"],
        "sort": [["bucket(\"price\", 0.5)", "desc"]],
        "filter": [["status", "==", "open"]],
        "expressions": {
            "if(\"side\"=='buy'){-1}else{1}": "if(\"side\"=='buy'){-1}else{1}",
            "bucket(\"price\", 0.5)": "bucket(\"price\", 0.5)"
        },
        "columns": ["if(\"side\"=='buy'){-1}else{1}"],
        "aggregates": {}
    },
    {
        "plugin": "X Bar",
        "plugin_config": {},
        "title": "Order Book (Chart)",
        "group_by": ["bucket(\"price\", 0.5)"],
        "split_by": ["side"],
        "columns": ["if(\"side\"=='buy'){-1}else{1}"],
        "filter": [["status", "==", "open"]],
        "sort": [["bucket(\"price\", 0.5)", "desc"]],
        "expressions": {
            "if(\"side\"=='buy'){-1}else{1}": "if(\"side\"=='buy'){-1}else{1}",
            "bucket(\"price\", 0.5)": "bucket(\"price\", 0.5)"
        },
        "aggregates": {}
    },
    {
        "plugin": "Candlestick",
        "plugin_config": {},
        "title": "Candlestick",
        "group_by": ["bucket(\"timestamp\", 'm')"],
        "split_by": [],
        "columns": ["price", null, "price 2", "price 3"],
        "filter": [["status", "==", "closed"]],
        "sort": [],
        "expressions": {
            "bucket(\"timestamp\", 'm')": "bucket(\"timestamp\", 'm')",
            "price 2": "\"price\"",
            "price 3": "\"price\""
        },
        "aggregates": {
            "price": "avg",
            "price 2": "high",
            "price 3": "low"
        }
    },
    {
        "plugin": "Candlestick",
        "plugin_config": {},
        "title": "Candlestick 2",
        "group_by": ["bucket(\"timestamp\", 'm')"],
        "split_by": [],
        "columns": ["price", null, null, null],
        "filter": [["status", "==", "closed"]],
        "sort": [],
        "expressions": {
            "bucket(\"timestamp\", 'm')": "bucket(\"timestamp\", 'm')",
            "price 2": "\"price\"",
            "price 3": "\"price\""
        },
        "aggregates": {
            "price": "avg",
            "price 2": "high",
            "price 3": "low"
        }
    },
    {
        "plugin": "X Bar",
        "plugin_config": {},
        "title": "Order Book (All Status)",
        "group_by": ["bucket(\"price\", 0.5)"],
        "split_by": [],
        "columns": [
            "if(\"status\"=='open' and \"side\"=='buy'){1}else{float(null)}",
            "if(\"status\"=='open' and \"side\"=='sell'){1}else{float(null)}",
            "if(\"status\"=='closed'){1}else{0}"
        ],
        "filter": [],
        "sort": [["bucket(\"price\", 0.5)", "desc"]],
        "expressions": {
            "if(\"status\"=='open' and \"side\"=='buy'){1}else{float(null)}": "if(\"status\"=='open' and \"side\"=='buy'){1}else{float(null)}",
            "bucket(\"timestamp\", 's')": "bucket(\"timestamp\", 's')",
            "bucket(\"price\", 0.5)": "bucket(\"price\", 0.5)",
            "if(\"status\"=='open'){\"price\"}else{float(null)}": "if(\"status\"=='open'){\"price\"}else{float(null)}",
            "if(\"status\"=='closed'){1}else{0}": "if(\"status\"=='closed'){1}else{0}",
            "if(\"status\"=='open' and \"side\"=='sell'){1}else{float(null)}": "if(\"status\"=='open' and \"side\"=='sell'){1}else{float(null)}"
        },
        "aggregates": {}
    },
    {
        "plugin": "Y Scatter",
        "plugin_config": {},
        "title": "Order Book (Scatter All Status)",
        "group_by": ["bucket(\"price\", 0.5)"],
        "split_by": [],
        "columns": [
            "if(\"status\"=='open' and \"side\"=='buy'){1}else{float(null)}",
            "if(\"status\"=='open' and \"side\"=='sell'){1}else{float(null)}",
            "if(\"status\"=='closed'){1}else{0}"
        ],
        "filter": [],
        "sort": [],
        "expressions": {
            "if(\"status\"=='open' and \"side\"=='buy'){1}else{float(null)}": "if(\"status\"=='open' and \"side\"=='buy'){1}else{float(null)}",
            "bucket(\"timestamp\", 's')": "bucket(\"timestamp\", 's')",
            "bucket(\"price\", 0.5)": "bucket(\"price\", 0.5)",
            "if(\"status\"=='open'){\"price\"}else{float(null)}": "if(\"status\"=='open'){\"price\"}else{float(null)}",
            "if(\"status\"=='closed'){1}else{0}": "if(\"status\"=='closed'){1}else{0}",
            "if(\"status\"=='open' and \"side\"=='sell'){1}else{float(null)}": "if(\"status\"=='open' and \"side\"=='sell'){1}else{float(null)}"
        },
        "aggregates": {}
    },
    {
        "plugin": "X Bar",
        "plugin_config": {},
        "title": "Order Book (Stack All Status)",
        "group_by": ["bucket(\"price\", 0.5)"],
        "split_by": ["if(\"status\"=='closed'){'closed'}else{\"side\"}"],
        "columns": ["price"],
        "filter": [["status", "!=", "expired"]],
        "sort": [
            ["bucket(\"price\", 0.5)", "desc"],
            ["status", "col asc"]
        ],
        "expressions": {
            "if(\"status\"=='open' and \"side\"=='buy'){1}else{float(null)}": "if(\"status\"=='open' and \"side\"=='buy'){1}else{float(null)}",
            "bucket(\"timestamp\", 's')": "bucket(\"timestamp\", 's')",
            "bucket(\"price\", 0.5)": "bucket(\"price\", 0.5)",
            "if(\"status\"=='open'){\"price\"}else{float(null)}": "if(\"status\"=='open'){\"price\"}else{float(null)}",
            "if(\"status\"=='closed'){1}else{0}": "if(\"status\"=='closed'){1}else{0}",
            "if(\"status\"=='open' and \"side\"=='sell'){1}else{float(null)}": "if(\"status\"=='open' and \"side\"=='sell'){1}else{float(null)}",
            "if(\"status\"=='closed'){'closed'}else{\"side\"}": "if(\"status\"=='closed'){'closed'}else{\"side\"}"
        },
        "aggregates": {}
    },
    {
        "columns_config": {},
        "plugin": "Candlestick",
        "plugin_config": {},
        "table": "market",
        "title": "Candlestick 3 Son Of Candllestick",
        "group_by": ["bucket(\"timestamp\", 'm')"],
        "split_by": [],
        "sort": [],
        "filter": [["status", "==", "closed"]],
        "group_rollup_mode": "flat",
        "split_rollup_mode": "flat",
        "expressions": {
            "price 3": "\"price\"",
            "price 2": "\"price\"",
            "bucket(\"timestamp\", 'm')": "bucket(\"timestamp\", 'm')"
        },
        "windows": {
            "New Column 3": {
                "column": "price",
                "aggregate": "avg",
                "rows": 100
            },
            "New Column 4": {
                "column": "price",
                "aggregate": "avg",
                "rows": 100
            },
            "New Column 1": {
                "column": "price",
                "aggregate": "avg",
                "rows": 100
            },
            "New Column 2": {
                "column": "price",
                "aggregate": "avg",
                "rows": 100
            }
        },
        "columns": [
            "New Column 1",
            "New Column 2",
            "New Column 3",
            "New Column 4",
            null
        ],
        "aggregates": {
            "New Column 3": "high",
            "New Column 2": "last",
            "New Column 4": "low",
            "New Column 1": "first"
        }
    }
]
